module.exports = __webpack_public_path__ + "img/leguminivora-glycinivorella.0ab7b666.jpg";